import Vue from 'vue'
import VueGtag from 'vue-gtag'
import store from '@state/store'
import { FEATURES } from '@constants/Text'
import { getAppVariant } from '@utils/environment'
// import router from '@router'

export const GTAG_MEASUREMENT_ID = 'G-Z98J3HBYFX'

// Variante do bundle ('beta' | 'prod' | 'local') — permite segmentar no GA4
// os usuários da versão beta (feature flag) contra a estável. Requer registrar
// a custom dimension "app_variant" (escopo user) no admin do GA4.
const APP_VARIANT = getAppVariant()

const MAX_GA_SYNC_RETRIES = 3
let gaSyncRetryCount = 0

function scheduleGaSyncRetry(fallbacks) {
  if (gaSyncRetryCount >= MAX_GA_SYNC_RETRIES) return
  gaSyncRetryCount += 1
  setTimeout(() => syncGoogleAnalyticsUser(fallbacks), 500 * gaSyncRetryCount)
}

function resolveGaUserFields({
  fallbackUserId,
  fallbackOfficeId,
  fallbackOfficeName,
  fallbackSaasStatus,
} = {}) {
  const currentUser = store.getters['user/currentUser'] || {}
  const currentOffice = currentUser.escritorio || {}
  return {
    userId: currentUser.id_interno || fallbackUserId,
    officeId: currentOffice.id_interno || fallbackOfficeId,
    officeName: currentOffice.nome || fallbackOfficeName,
    hasSaasFeature:
      typeof store.getters['parameters/canShow'] === 'function'
        ? store.getters['parameters/canShow'](FEATURES.SAAS)
        : fallbackSaasStatus,
  }
}

function syncGoogleAnalyticsUser(fallbacks = {}) {
  const gtag = Vue.$gtag
  if (!gtag) {
    scheduleGaSyncRetry(fallbacks)
    return
  }

  gaSyncRetryCount = 0

  const { userId, officeId, officeName, hasSaasFeature } =
    resolveGaUserFields(fallbacks)

  if (!userId) {
    return
  }

  try {
    gtag.config({
      id: GTAG_MEASUREMENT_ID,
      params: {
        // O page_view é emitido pelo router (afterEach). Sem isto, cada
        // config() dispara um page_view extra — e esta função roda em watcher
        // deep sobre o usuário e os parâmetros, então repetiria por sessão.
        send_page_view: false,
        user_id: userId,
        id_escritorio: officeId,
        nome_escritorio: officeName,
        saas_enabled: hasSaasFeature,
        app_variant: APP_VARIANT,
      },
    })

    gtag.query('set', 'user_properties', {
      user_id: userId,
      office_id: officeId,
      office_name: officeName,
      saas_enabled: hasSaasFeature,
      app_variant: APP_VARIANT,
    })
  } catch (err) {
    console.log('[GA] Erro ao sincronizar usuário', err)
  }
}

export const init = ({ id_interno, id_escritorio } = {}) => {
  // this.$gtag.config({ user_id: 'foo' })
  try {
    const hasSaasFeature =
      typeof store.getters['parameters/canShow'] === 'function'
        ? store.getters['parameters/canShow'](FEATURES.SAAS)
        : undefined

    const fallbackOfficeName =
      ((store.getters['user/currentUser'] || {}).escritorio || {}).nome

    Vue.use(VueGtag, {
      config: {
        id: GTAG_MEASUREMENT_ID,
        params: {
          // Mesmo motivo do config() acima: quem emite page_view é o router.
          send_page_view: false,
          user_id: id_interno,
          id_escritorio: id_escritorio,
          app_variant: APP_VARIANT,
        },
      },
      // router, // Monitorar rotas automaticamente
    })

    syncGoogleAnalyticsUser({
      fallbackUserId: id_interno,
      fallbackOfficeId: id_escritorio,
      fallbackOfficeName,
      fallbackSaasStatus: hasSaasFeature,
    })

    store.watch(
      () => store.getters['user/currentUser'],
      () =>
        syncGoogleAnalyticsUser({
          fallbackUserId: id_interno,
          fallbackOfficeId: id_escritorio,
          fallbackOfficeName,
          fallbackSaasStatus: hasSaasFeature,
        }),
      { deep: true }
    )

    store.watch(
      () => store.getters['parameters/show'],
      () =>
        syncGoogleAnalyticsUser({
          fallbackUserId: id_interno,
          fallbackOfficeId: id_escritorio,
          fallbackOfficeName,
          fallbackSaasStatus: hasSaasFeature,
        }),
      { deep: true }
    )
  } catch (err) {
    console.log(err)
  }
}
